<template>
    <div class="flex items-center">
        <div class="flex w-full">
            <input
                class="mt-1 px-3 py-2 focus:border-gray-400 focus:outline-none block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md"
                autocomplete="off"
                type="text"
                name="search"
                placeholder="Search…"
                :value="modelValue"
                @input="$emit('update:modelValue', $event.target.value)"
            />
        </div>
        <button
            class="ml-3 text-gray-500 hover:text-gray-700 focus:outline-none text-sm"
            type="button"
            @click="$emit('reset')"
        >
            Reset
        </button>
    </div>
</template>

<script>
export default {
    emits: ['update:modelValue', 'reset'],
    props: {
        modelValue: String,
        maxWidth: {
            type: Number,
            default: 300
        }
    }
};
</script>
